var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"b-editor-excel-cell",class:{ 'is-error': _vm.isError },attrs:{"data-cell_uuid":_vm.cell_uuid,"title":_vm.title},domProps:{"textContent":_vm._s(_vm.label)},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }